const $body   = document.body;

let $players   = [];

const init = (instance) => {

    let startFlag = true;

    // Собираем плееры
    [...document.querySelectorAll("iframe[src*='(player.vgtrk.com|player.smotrim.ru|player2.smotrim.ru)']:not([name='mini_player_iframe'])")].forEach((player, i) => {
        $players.push({
            frame:     player.contentWindow,
            $el:       player,
            isPlaying: (player.getAttribute('src').indexOf('isPlay/true') > -1)
        })
    })

     window.addEventListener('scroll', watch);
     window.addEventListener('resize', watch);
     window.addEventListener("message", (event) => {
         if (typeof window.frames['mini_player_iframe'] !== 'undefined' && (window.frames['mini_player_iframe'] === event.source)) {

             let data = {};
             try {
                data = JSON.parse(event.data);
             } catch (e) {}
             if (data.message !== 'undefined' && data.message === 'started' && startFlag) {
                $players[0].frame.postMessage('play', '*');
                 startFlag = false;
             }

         }
     });
};

const watch = () => {
    let scrollTop  = window.scrollTop || window.pageYOffset;
    let breakpoint = $body.offsetHeight - window.innerHeight * 4;


    [...$players].forEach($player => {
        let windowHeight = window.innerHeight;
        let offsetTop    = $player.$el.getBoundingClientRect().top;
        let offsetBottom = $player.$el.getBoundingClientRect().bottom;
        let height50=(offsetBottom-offsetTop)/2;
        if (offsetTop <= (windowHeight-height50) && offsetBottom >= height50) {
            if (!$player.isPlaying) {
                $player.frame.postMessage('play', '*');
                $player.isPlaying = true;
            }
        } else {
            if ($player.isPlaying) {
                $player.frame.postMessage('pause', '*');
                $player.isPlaying = false;
                window.frames['mini_player_iframe'].postMessage('play', '*');
            }
        }
    });

};

export default class VideoScrollControl {
    constructor() {
        return window.location.pathname.match('/article/') ?  {} : init(this);
    }

}
